module.exports = __webpack_public_path__ + "img/amcc.2a80d2f1.jpg";